import React, {useMemo} from "react"
import {DateObject} from "react-multi-date-picker";
import PropTypes from "prop-types";
import useBookable from "../../hooks/useBookable";
import useBooking from "../../hooks/useBooking";
import Calendar from "../Calendar/Calendar"
import usePrice from "../../hooks/usePrice";
import Price from "../../components/Price/Price";
//import './style.scss'

const CalendarProfile = (props) => {

  const {
    dates,
    setDates,
    bookable,
    booking,
    isLoadingBookings,
    showHeader = true,
    // hideCalendar,
    // setHideCalendar,
    enableDisabledDays = false,
    loadMonthBookings,

  } = props


  const {
    getDayPriceByKey,
    getBookingPriceDaySpot,
    getDayKey,
    addBookingFeeIfNeeded,
    hasDifferentDayPrices,
  } = usePrice()
  const {isStand} = useBookable()
  const {isBookedBooking, isAvailableBooking, isDateInBooking, getBookingDates} = useBooking()

  /**
   * Find the first relevant date to show in the calendar:
   * 1. If there are already selected dates, use the first one
   * 2. Otherwise, find the first available AND not-booked date
   */
  const current = useMemo(() => {
    const today = new DateObject()

    // Priority 1: If there are already selected dates in the booking, go to the first one
    if (booking) {
      const bookingDates = getBookingDates(booking)
      if (bookingDates && bookingDates.length > 0) {
        // Sort dates and return the first one
        const sortedDates = [...bookingDates].sort((a, b) => a.toDays() - b.toDays())
        return sortedDates[0]
      }
    }

    // Priority 2: Find the first available date (checking both availability AND bookings)
    if (!bookable || !booking) return null

    const availableValue = parseInt(bookable.available)

    // available = 0: Not available at all, show today
    if (availableValue === 0) return null

    // available = 1: Always available, find first non-booked date
    if (availableValue === 1) {
      for (let i = 0; i < 365; i++) {
        const checkDate = new DateObject().add(i, 'days')
        if (!isBookedBooking(bookable, booking, checkDate)) {
          return checkDate
        }
      }
      return null
    }

    // available = 2: Specific dates/schedule
    if (availableValue === 2) {
      // If there are specific available_dates, use those directly (more efficient)
      if (bookable.available_dates && bookable.available_dates.length > 0) {
        const futureDates = bookable.available_dates
          .filter(ad => ad.open && new DateObject(ad.date).toDays() >= today.toDays())
          .sort((a, b) => new Date(a.date) - new Date(b.date))

        // Find first available_date that is not booked
        for (const ad of futureDates) {
          const checkDate = new DateObject(ad.date)
          if (!isBookedBooking(bookable, booking, checkDate)) {
            return checkDate
          }
        }
      }

      // If availability_on_going with weekly schedule, search day by day
      if (bookable.availability_on_going && bookable.availabilities && bookable.availabilities.length > 0) {
        for (let i = 0; i < 365; i++) {
          const checkDate = new DateObject().add(i, 'days')
          if (isAvailableBooking(bookable, booking, checkDate) && !isBookedBooking(bookable, booking, checkDate)) {
            return checkDate
          }
        }
      }
    }

    return null
  }, [bookable, booking, getBookingDates, isAvailableBooking, isBookedBooking])

  /**
   *
   * @param date
   * @param className
   * @returns {JSX.Element}
   */
  const calendarDay = (date, className = '') => {
    let dayPrice = 0
    const dayKey = getDayKey(date.weekDay.index)
    const newDate = new DateObject(date)

    if (isStand(bookable)) {
      dayPrice = getDayPriceByKey(bookable, dayKey)
    } else {

      let spotsHaveDifferentDayPrices = false

      booking.spots && booking.spots.map((spot) => {

        if (hasDifferentDayPrices(spot)) {
          spotsHaveDifferentDayPrices = true
        }

        /*
         * Only show dayPrices if price for day in the week is different.
         * check if booking has spots with different price types,
         * if so, do not show price
         */
        if (!spotsHaveDifferentDayPrices) {
          dayPrice = null
        } else if (spot.price.type !== 'negotiate' && spot.price.type !== 'relative' && booking.spots[0].price.type === spot.price.type) {
          dayPrice += addBookingFeeIfNeeded(booking, bookable, getBookingPriceDaySpot(spot, bookable, dayKey))
        } else if (spot.price.type === 'relative' && booking.spots[0].price.type === spot.price.type) {
          //todo could be possible to show average of relative prices
          //or like getBookingTotalFormattedPercentagesRelative() (see Totals.js)
          if (booking.spots.length === 1) {
            dayPrice = addBookingFeeIfNeeded(booking, bookable, getBookingPriceDaySpot(spot, bookable, dayKey))
          } else {
            dayPrice = null
          }

        } else {
          dayPrice = null
        }
        return spot
      })
    }

    return (<div className={"calendar-day " + className}>
      <div className="date">{newDate.format("D")}</div>
      {!enableDisabledDays && <div className="price">
        {(dayPrice === null) && '...'}
        {(dayPrice === 0) && 0}
        {(dayPrice > 0) && dayPrice}</div>}
    </div>)
  }

  const mapDays = ({date, today, selectedDate, currentMonth, isSameDate}) => {
    const daysFromNow = date.toDays() - today.toDays()
    let props = {}
    let extraClassName = ''
    if (daysFromNow < 0) {
      return {
        disabled: true,
        // style: (!enableDisabledDays) ? {color: "#ccc"} : {}, // onClick: () => swal("Deze dag is al geweest")
        style: {color: "#ccc"}, // onClick: () => swal("Deze dag is al geweest")
      }
    }

    if (isAvailableBooking(bookable, booking, date)) {
      if (isBookedBooking(bookable, booking, date)) {
        return {
          className: (isDateInBooking(booking, date)) ? ' unavailable-but-selected ' : '',
          // disabled: true,
          // style: {color: "red"},
          // onClick: () => swal("Een of meer van de nu geselecteerde (dus groene) standplaatsen/Spots zijn niet vrij op deze dag. Probeer een of meer andere andere standplaatsen")
          // className: (enableDisabledDays)?' selected-but-unavailable1 ':'',
          // disabled: (!enableDisabledDays),
          // style: (!enableDisabledDays) ? {color: "#ccc"} : {},
          // onClick: () => swal("Deze dag is niet beschikbaar")
          // onClick: (enableDisabledDays) ? null : () => swal("Deze dag is niet beschikbaar")
          disabled: (!isDateInBooking(booking, date)),
          style: {color: "#ccc"},
        }
      }
    } else {
      return {
        className: (isDateInBooking(booking, date)) ? ' unavailable-but-selected ' : '',
        // className: (enableDisabledDays)?' selected-but-unavailable2 ':'',
        // disabled: (!enableDisabledDays),
        disabled: (!isDateInBooking(booking, date)),
        // style: (!enableDisabledDays) ? {color: "#ccc"} : {},
        style: {color: "#ccc"},
        // onClick: (enableDisabledDays) ? null : () => swal("Deze dag is niet beschikbaar")
        // onClick: () => swal("Deze dag is niet beschikbaar")
      }
    }

    if (daysFromNow === 0) props.title = "Vandaag"
    if (daysFromNow === 1) props.title = "morgen"
    props.children = calendarDay(date, extraClassName)
    return props
  }

  return (
    <div className="component-calendar-profile">
      {showHeader && <div className="header">
        <div className="price">
          <Price bookable={bookable} showTooltip={true} showInfo={true}/>
        </div>
      </div>}

      <Calendar
        dates={dates}
        setDates={setDates}
        isLoadingBookings={isLoadingBookings}
        loadMonthBookings={loadMonthBookings}
        current={current}
        mapDays={mapDays}
      />
    </div>)
}

CalendarProfile.propTypes = {
  enableDisabledDays: PropTypes.bool,
  showHeader: PropTypes.bool,
  // dates: PropTypes.object.isRequired,
  // setDates: PropTypes.object.isRequired,
  // bookable: PropTypes.object.isRequired,
  // booking: PropTypes.object.isRequired,
}

export default CalendarProfile
